<template>
    <div v-show="visible">
        <el-dialog
            title="派发记录"
            :close-on-click-modal="false"
            :visible.sync="visible"
            width="850px"
            :modal="false"
            append-to-body
            :before-close="handleClose">
            <div style="margin-bottom:10px;">
                <el-input v-model="queryForm.orgName" placeholder="派发机构" style="width: 230px;"></el-input>
                <el-button type="primary" icon="search" @click="common.page=1;getData()" style="margin-left:10px;">查询</el-button>
            </div>

            <el-table
                :data="records"
                v-loading="loading"
                element-loading-text="数据正在加载中..."
                element-loading-background="rgba(255, 255,255,0.7)"
                border
                height="420">
                <el-table-column prop="orgName" label="派发机构" min-width="160"></el-table-column>
                <el-table-column prop="productType" label="商品类型" width="110">
                    <template slot-scope="scope">
                        <span v-if="scope.row.productType == 1">VIP</span>
                        <span v-else-if="scope.row.productType == 2">SVIP</span>
                        <span v-else-if="scope.row.productType == 3">BVIP</span>
                        <span v-else>{{scope.row.productType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="金额" width="100"></el-table-column>
                <el-table-column prop="startDate" label="开始日期" width="120"></el-table-column>
                <el-table-column prop="expiryDate" label="有效日期" width="120"></el-table-column>
                <el-table-column prop="gmtCreate" label="派发时间" width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" style="color: red" @click.native.prevent="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination" style="margin-top:10px;text-align:right;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible:false,
                loading:false,
                records:[],
                common:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100],
                },
                queryForm:{
                    orgName:""
                }
            }
        },
        methods:{
            init(data){
                this.visible=true;
                this.queryForm.orgName = this.$util.isNotEmpty(data) && this.$util.isNotEmpty(data.orgName) ? data.orgName : "";
                this.common.page = 1;
                this.getData();
            },
            handleClose(done){
                this.visible = false;
                this.$emit('closed');
                done();
            },
            del(row){
                this.$commonFn.showConfirm(() => this.delSuccess(row));
            },
            delSuccess(row){
                let url = this.deptDispatchCouponRecordRemoveUrl;
                let data = {
                    id: row.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        if(this.records.length === 1 && this.common.page > 1){
                            this.common.page = this.common.page - 1;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            getData(){
                this.loading=true;
                let url = this.deptDispatchCouponRecordListUrl;
                let data = {
                    isPage:this.common.isPage,
                    currentPage:this.common.page,
                    limit:this.common.pageSize,
                    orgName: this.queryForm.orgName
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.records = res.data.data;
                        this.common.total = res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/dept/DispatchCouponRecord.vue